import {
  levelOneSummaryMessage,
  levelTwoSummaryMessage,
  levelZeroSummaryMessage,
  UN_CAPTURED_REVENUE_LEVEL,
} from '../../App.constants';

export const getSummaryMessage = (uncapturedRevenue: number): string => {
  if (uncapturedRevenue <= 0) {
    return levelZeroSummaryMessage;
  }

  if (uncapturedRevenue > 0 && uncapturedRevenue <= UN_CAPTURED_REVENUE_LEVEL) {
    return levelOneSummaryMessage;
  }

  return levelTwoSummaryMessage;
};
